import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  CartesianAxis,
  XAxis,
  YAxis,
  Tooltip,
} from 'recharts';
import ChartTooltip from '@/shared/ui/charts/ChartTooltip';

type AxisType = {
  dataKey?: any;
  orientation?: 'left' | 'right';
  formatter?: (value:any) => any;
  domain?: any;
  allowDecimals?: boolean;
}

type BarChartProps = {
  data: any[],
  emptyStateData?: any,
  lines: {
    name: string;
    dataKey: string;
    stroke: string;
  }[],
  tooltipValueFormatter?: (value:any) => any,
  tooltipLabelFormatter?: (value:any) => any,
  XAxisProps: AxisType,
  YAxisProps: AxisType,
  className?: string;
  dateRange?: string;
  isLoading?: boolean;
}

const BarChartUI = (props: BarChartProps) => {
  const { 
    data = [],
    emptyStateData = [{}],
    lines = [],
    tooltipLabelFormatter = (value) => value,
    tooltipValueFormatter = (value) => value,
    XAxisProps = {
      dataKey: '',
      formatter: (value) => value,
    },
    YAxisProps = {
      dataKey: '',
      formatter: (value) => value,
      domain: ['dataMin', 'dataMax'],
      allowDecimals: false,
    },
    className = 'w-full h-[300px] p-5',
    isLoading = false,
  } = props;

  const chartData = (data.length === 0 && emptyStateData.length !== 0 && !isLoading) ? emptyStateData : data;

  return (
    <div className={className}>
      <ResponsiveContainer>
        <BarChart
          barGap={0}
          width={500}
          height={400}
          data={chartData}
          margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0,
          }}
        >
          <defs>
            <linearGradient id="chartColorPrimary" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#00ccaa" stopOpacity={0.45}/>
              <stop offset="100%" stopColor="#00ccaa" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid 
            stroke="#fff" 
            strokeOpacity={0.08} 
            vertical={false}
          />
          <CartesianAxis />
          {XAxisProps.dataKey ? (
            <XAxis 
              dataKey={XAxisProps.dataKey}
              tickFormatter={XAxisProps.formatter}
              tick={{fontSize: 12}}
              height={22}
              tickMargin={5}
            />
          ) : null}
          {YAxisProps.dataKey ? (
            <YAxis
              type='number'
              orientation="right"
              tickFormatter={YAxisProps.formatter}
              tick={{fontSize: 12, fontWeight: 300}}
              width={25}
              domain={YAxisProps.domain}
              allowDecimals={YAxisProps.allowDecimals}
            />
          ) : null}
          <Tooltip
            cursor={{fill: '#fff', opacity: 0.08}}
            animationDuration={100}
            content={<ChartTooltip />}
            formatter={tooltipValueFormatter}
            labelFormatter={tooltipLabelFormatter}
          />
          {
            lines.map((line) => {
              return (
                <Bar
                  stackId="a"
                  type="monotone"
                  key={line.name + '-bar'}
                  fill={line.stroke}
                  name={line.name}
                  dataKey={line.dataKey}
                  // radius={2}
                />
              )
            })
          }
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default BarChartUI;
